import { quranStructure, TOTAL_QURAN_VERSES } from './constants';

// Calculate total progress (percentage of Quran completed)
export const calculateTotalProgress = (currentSurah, currentVerse) => {
  let totalVersesSoFar = 0;
  for (let i = 0; i < currentSurah - 1 && i < quranStructure.length; i++) {
    totalVersesSoFar += quranStructure[i].totalVerses;
  }
  totalVersesSoFar += currentVerse;
  return (totalVersesSoFar / TOTAL_QURAN_VERSES) * 100;
};

// Get total verses for a surah
export const getSurahTotalVerses = (surahNumber) => {
  const surah = quranStructure.find(s => s.number === surahNumber);
  return surah ? surah.totalVerses : 0;
};

// Calculate progress within current surah
export const calculateSurahProgress = (currentSurah, currentVerse) => {
  const totalVerses = getSurahTotalVerses(currentSurah);
  return totalVerses ? (currentVerse / totalVerses) * 100 : 0;
};

// Get surah info by number
export const getSurahInfo = (surahNumber) => {
  return quranStructure.find(s => s.number === surahNumber) || quranStructure[0];
};

// Surah 1 (Al-Fatihah) and Surah 9 (At-Tawbah) open without a separate Bismillah.
// Everywhere else verse 0 is the Bismillah that precedes verse 1.
export const surahHasBismillah = (surahNumber) => surahNumber !== 1 && surahNumber !== 9;

// The position after the given one, or null at the end of the Quran.
export const nextPosition = (surah, verse) => {
  if (verse === 0) return { surah, verse: 1 };

  if (verse < getSurahTotalVerses(surah)) return { surah, verse: verse + 1 };

  if (surah >= 114) return null;
  const next = surah + 1;
  return { surah: next, verse: surahHasBismillah(next) ? 0 : 1 };
};

// The position before the given one, or null at the start of the Quran.
export const previousPosition = (surah, verse) => {
  if (verse === 1 && surahHasBismillah(surah)) return { surah, verse: 0 };

  if (verse > 1) return { surah, verse: verse - 1 };

  if (surah <= 1) return null;
  const previous = surah - 1;
  return { surah: previous, verse: getSurahTotalVerses(previous) };
};
